import React from 'react'
import { Sale } from 'src/core/models'
import { ProjectSaleColumn, FormLabels, SaleListActions, SaleStatusColumn } from 'src/components'
import { useTranslation } from 'next-i18next'
import { selectCurrencyToken } from 'src/features'
import { useAppSelector } from 'src/app/hooks'
import { getDateFormatted, getFormatedPrice, getProjectUnitUd } from 'src/core/helpers'
import styles from './SaleItemMovileViewColumn.module.scss'

const SaleItemMovileViewColumn: React.FC<{ sale: Sale }> = ({ sale }) => {
  const { t } = useTranslation()
  const currency_code = useAppSelector(selectCurrencyToken)

  return <>
    <ProjectSaleColumn sale={sale} />
    <FormLabels
      title={getFormatedPrice(sale.amount, currency_code)}
      subtitle={`${sale.co2_amount} ${getProjectUnitUd(sale.projectKind, t, sale.co2_amount)}`}
      thirdLabel={getDateFormatted(sale.created)}
    />
    <div className={styles.content}>
      <SaleStatusColumn sale={sale} />
      <div className={styles.actions}>
        <SaleListActions sale={sale} />
      </div>
    </div>
  </>
}

export default SaleItemMovileViewColumn
